const firebaseConfig = {
    apiKey: "AIzaSyDEpOOfB-9_oyXDW7QR2QrFkMw12XMyGdI",
    authDomain: "crypto-bash.firebaseapp.com",
    projectId: "crypto-bash",
    storageBucket: "crypto-bash.appspot.com",
    messagingSenderId: "216616379552",
    appId: "1:216616379552:web:3f85fd65b88fcadcc615c5"
  };

  export default firebaseConfig;